import { Typography, styled } from '@mui/material';

const StyledSessionCardDate = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 700,
  letterSpacing: '-0.01em',
  marginBottom: theme.spacing(0.5)
}));

export default StyledSessionCardDate;
